import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Locations API
export const getLocations = async () => {
  try {
    const response = await axios.get(`${API}/locations`);
    return response.data;
  } catch (error) {
    console.error('Error fetching locations:', error);
    throw error;
  }
};

export const getLocationById = async (id) => {
  try {
    const response = await axios.get(`${API}/locations/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching location:', error);
    throw error;
  }
};

// Bookings API
export const createBooking = async (bookingData) => {
  try {
    const response = await axios.post(`${API}/bookings`, bookingData);
    return response.data;
  } catch (error) {
    console.error('Error creating booking:', error);
    throw error;
  }
};

export const getBookings = async () => {
  try {
    const response = await axios.get(`${API}/bookings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching bookings:', error);
    throw error;
  }
};

// Testimonials API
export const getTestimonials = async () => {
  try {
    const response = await axios.get(`${API}/testimonials`);
    return response.data;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    throw error;
  }
};

export const getVerifiedTestimonials = async () => {
  try {
    const response = await axios.get(`${API}/testimonials/verified`);
    return response.data;
  } catch (error) {
    console.error('Error fetching verified testimonials:', error);
    throw error;
  }
};

export const createTestimonial = async (testimonialData) => {
  try {
    const response = await axios.post(`${API}/testimonials`, testimonialData);
    return response.data;
  } catch (error) {
    console.error('Error creating testimonial:', error);
    throw error;
  }
};

// Gallery API
export const getGalleryItems = async (params = {}) => {
  try {
    const response = await axios.get(`${API}/gallery`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching gallery items:', error);
    throw error;
  }
};

export const getFeaturedGalleryItems = async () => {
  try {
    const response = await axios.get(`${API}/gallery`, { params: { featured: true } });
    return response.data;
  } catch (error) {
    console.error('Error fetching featured gallery items:', error);
    throw error;
  }
};

// Contact API
export const createContactMessage = async (contactData) => {
  try {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  } catch (error) {
    console.error('Error creating contact message:', error);
    throw error;
  }
};

export const getContactMessages = async (params = {}) => {
  try {
    const response = await axios.get(`${API}/contact`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching contact messages:', error);
    throw error;
  }
};

// Health check
export const healthCheck = async () => {
  try {
    const response = await axios.get(`${API}/`);
    return response.data;
  } catch (error) {
    console.error('Error with health check:', error);
    throw error;
  }
};
